"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServiceHost = exports.isDev = exports.isRN = exports.isBrowser = exports.attempt = void 0;
const lodash_1 = require("lodash");
const attempt = (fn) => {
    let result;
    try {
        result = fn();
    }
    catch (e) {
        result = e;
    }
    return result;
};
exports.attempt = attempt;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
const isRN = () => typeof navigator !== "undefined" && navigator.product === "ReactNative";
exports.isRN = isRN;
const isDev = () => ((0, exports.isBrowser)() &&
    typeof (0, lodash_1.get)(window, "location.hostname.includes") === "function" &&
    window.location.hostname.includes("local")) ||
    (typeof window === "undefined" &&
        typeof process.env.ENVIRONMENT === "string" &&
        process.env.ENVIRONMENT === "dev");
exports.isDev = isDev;
const getServiceHost = (envConfig) => (0, exports.isBrowser)()
    ? `//${envConfig.service_host}`
    : `http://${envConfig.service_host}`;
exports.getServiceHost = getServiceHost;



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/utils.js